import { Component, OnInit, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { Location, DatePipe } from '@angular/common';
// import { proposalData } from '../personal-accident-proposal/proposal-data.model';
import { SharingDataService } from '../service/sharing-data.service';
import { ToasterService } from '../services/toaster.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from '../../environments/environment';
import { proposalData } from './family-health-care-data.modal';
import { WindowRef } from '../service/WindowRef.service';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import moment from 'moment';
import * as $ from 'jquery';
declare var $: any;
@Component({
  selector: 'app-family-health-care-proposal',
  templateUrl: './family-health-care-proposal.component.html',
  styleUrls: ['./family-health-care-proposal.component.css'],
  providers: [ToasterService]
})
export class FamilyHealthCareProposalComponent implements OnInit {
  proposal: proposalData = new proposalData();
  modalRef: BsModalRef;
  thankyouSection: boolean;
  transactionFailureSection: boolean = false;
  // proposal: any ;
  adhaar: string;
  activeTab: string = 'proposerDetails';
  loading: boolean = false;
  royalStateList: any = [];
  royalCityList: any = [];
  quoteDetails: any;
  proposalTab: boolean = false;
  invalidPincode: boolean;
  insurerDetails: boolean = true;
  nomineeDetails: boolean = true;
  healthDetails: boolean = true;
  totalMember: any;
  royalPremiumDetails: any;
  finalPremiumCheck: boolean = false;
  healthThankYou: boolean = false;
  selfProposalTab: boolean = false;
  spouseProposalTab: boolean = false;
  child1ProposalTab: boolean = false;
  child2ProposalTab: boolean = false;
  child3ProposalTab: boolean = false;
  goodHealthDeclaraion: boolean = false;
  DOBrequired: boolean;
  shouldBe18: boolean;
  public environment = environment;
  nomineeAddressAutoFillValue: string = "No";
  nomineeGaurdianDetails: boolean;
  nomineeDOBrequired: boolean = false;
  currentDate: Date;
  getGaurdianMinDate: Date;
  maxYearGaurdianDate: number;
  smokingInsurer1: string = "No";
  personFlag: any;
  paymentGateData: any = {};
  membersCount: any;
  diagYears: any = [];
  errorMsg: any;
  error: any;
  data: {};
  txnId: string = '';
  rzp1: any;
  secureNowTxnRefNo: string;
  transactionId: string;
  private onDestroy$: Subject<void> = new Subject<void>();
  proposalForm: any = {
    question1: false,
    question2: false,
    question3: false,
    question4: false,
    question5: false,
    question6: false,
    question7: false,
    question8: false,
    question9: false,
  }
  @ViewChild('royalSundarmForm', { static: false }) royalSundarmForm: ElementRef;
  birthYear: moment.Moment;



  //options for RazorPay
  options = {
    key: environment.covidRazorpayKey, 
    //amount: this.savedTotalPremium, //  = INR 1
     name: 'Secure now',
     description: 'Purchase description',
     image: "https://pamstaging2.securenow.in/static/images/securenow_logo.svg",
     order_id: this.txnId,
    //  callback_url: 'https://www.google.com',
     handler: function (response){
      this.secureNowTxnRefNo = localStorage.getItem("secureNowTxnRefNo");
      this.transactionId = localStorage.getItem("transactionId");
      this.transactionData = {
        "txnId": this.secureNowTxnRefNo,
        "razorpaySignature": response.razorpay_signature,
        "razorpayPaymentId": response.razorpay_payment_id
      }
      
      if (typeof response.razorpay_payment_id == 'undefined' ||  response.razorpay_payment_id < 1) {
        alert("error with payment Id "+response.razorpay_payment_id);
      } else {
        this.loading = true;
        console.log("loading -"+this.loading);
        $.ajax({
          url: environment.msUrl+"/individual-insurance/api/v1/transaction/payment-acknowledge-razorpay?secureNowTxnRefNo="+this.secureNowTxnRefNo+"&txnId="+this.transactionId+"&razorpaySignature="+response.razorpay_signature+"&razorpayPaymentId="+response.razorpay_payment_id,
          type: "POST",
          data: '',
          contentType: "application/json; charset=utf-8",
          success: function (data) {
            this.loading = true;
              console.log(data.message, data.success);
              var status = data.success;    
                location.href = '/senior-citizen-transaction/status/' + status;
          },
          error: function(data){
            this.loading = true;
            var status = false;
            location.href = '/senior-citizen-transaction/status/' + status;
            // alert(data.message);
            this.transactionFailureSection = true;
            // location.href = '/';
          }
        })
      }
 
     },
     prefill: {

     },
     notes: {

     },
     theme: {
         color: "#005BAA"
     },
  };

  constructor(private router: Router, private modalService: BsModalService, public datepipe: DatePipe, private serviceURLService: serviceURLService, public sharingDataService: SharingDataService, private winRef: WindowRef, private toasterService: ToasterService) { }

  ngOnInit() {
    // this.getStateCityForRoyal(1, '');
    this.quoteDetails = JSON.parse(sessionStorage.fhiProposal);
    this.membersCount = 1 + (this.quoteDetails.childSize ? +this.quoteDetails.childSize : 0) + (this.quoteDetails.isspouse ? 1 : 0);
    console.log(this.membersCount);
    // this.sharingDataService.familyHealthData.subscribe(data => 
    //   this.quoteDetails = data);
    // if (this.quoteDetails) {
    //   this.getPremiumForRoyalSundram();
    // }
    this.proposal.authorizedSignatoryDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy')
    this.currentDate = new Date();
    this.getPrefilledData();
  }

  getPrefilledData() {
    const fullName = localStorage.getItem('name');
    const nameSplit = fullName.split(' ');
    this.proposal.firstName = nameSplit[0];
    this.proposal.emailId = localStorage.getItem('email');
    this.proposal.mobileNo = localStorage.getItem('mobileNumber');
  }

  getStateCityForRoyal(type, state) {
    this.loading = true;
    console.log(type, state);
    const cityData = {
      type: type,
      state: state,
    };

    this.serviceURLService.getCityStateForRoyalSundaram(cityData).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
      if (cityData.type === 1) {
        this.royalStateList = successData.data;
      } else {
        this.royalCityList = successData.data;
      }
    }, errorData => {
      this.loading = false;
    });
  }


  // we have make it common
  dateConvert(value: any) {
    let myMoment: moment.Moment = moment(value);
    const convertedValue = new Date(value).getTime();
    const newDate = new Date(convertedValue);
    const finalConvertDate = (newDate.getDate() + '/' + (newDate.getMonth() + 1) + '/' + newDate.getFullYear());
    return finalConvertDate;
  }

  calculateAge() {
    this.nomineeDOBrequired = false;
    var dobNominee = new Date(this.proposal.nomineeDob);
    console.log(dobNominee);
    var ageDifMs = Date.now() - dobNominee.getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    let ageDifference = Math.abs(ageDate.getUTCFullYear() - 1970);
    if (ageDifference < 18) {
      this.nomineeGaurdianDetails = true;
    } else {
      this.nomineeGaurdianDetails = false;
    }
  }

  saveOrSubmitCareProposalPage() {
    this.loading = true;
    if(this.proposal.insuredPersonTitle1 === 'Mrs' || this.proposal.insuredPersonTitle1 === 'MS') {
      this.proposal.insuredPersonTitle1 = 'F';
    }
    this.proposal.insuredMemberRelation2 = this.quoteDetails.isspouse ? 'SPOUSE' : '';
    // this.proposal.totalMembers = this.totalMember;
    this.proposal.quoteId = this.quoteDetails.quoteId;
    this.proposal.insurerName = "Care Health";
    this.proposal.sumInsured = 'Rs. ' + this.quoteDetails.quoteDetails.XLEW_2_2_5;
    // this.proposal.age = this.quoteDetails.quoteDetails.XLEW_1_3_3;
    this.proposal.prospectId = this.quoteDetails.prospectId;
    // this.proposal.productName = 'Family Health Insurance';
    this.proposal.premium = localStorage.getItem('carePremium');

    let proposalDob = this.datepipe.transform(this.proposal.dob, 'dd/MM/yyyy');
    this.proposal.dob = proposalDob;

    var dobInsuredPersonOne = String(this.proposal.insuredPersonDob1);
    if(dobInsuredPersonOne.includes('/')){
      console.log(this.proposal.insuredPersonDob1);
    } else {
      let insuredPersonDob1 = this.datepipe.transform(dobInsuredPersonOne, 'dd/MM/yyyy');
      this.proposal.insuredPersonDob1 = insuredPersonDob1;
    }
    

    var dobInsuredPersonTwo = String(this.proposal.insuredPersonDob2);
    if(dobInsuredPersonTwo.includes('/')){
      console.log(this.proposal.insuredPersonDob2);
    } else {
      let insuredPersonDob2 = this.datepipe.transform(dobInsuredPersonTwo, 'dd/MM/yyyy');
      this.proposal.insuredPersonDob2 = insuredPersonDob2;
    }

    var dobNominee= String(this.proposal.nomineeDob);
    if(dobNominee.includes('/')){
      console.log(this.proposal.nomineeDob);
    } else {
      let nomineeDob = this.datepipe.transform(dobNominee, 'dd/MM/yyyy');
      this.proposal.nomineeDob = nomineeDob;
    }

    // this.proposal.typeOfPlan = "Supreme"

    // this.addtionalMedicalQuestion();

    console.log("save Data ", this.proposal);
    this.serviceURLService.careFamilyHealthSaveProspect(this.proposal).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {


      this.loading = false;
      //this.healthThankYou = true;
      //this.healthDetails = true;
      var toaster = document.getElementById("snackbar");
          toaster.innerHTML = "Proposal data saved successfuly";
          toaster.className = "show";
      setTimeout(function () { toaster.className = toaster.className.replace("show", ""); }, 3000);
      // this.toasterService.showSuccessToaster(successData.message);
    }, errorData => {
      this.loading = false;

    });
  }

  // set diag year of add quest
  setDiagYearOfAddQuestions(dob) {
    let submityear = dob.getFullYear();
    var currentDate = new Date();
    var currentYear = currentDate.getFullYear();
    for (var i = submityear; i <= currentYear; i++) {
      this.diagYears.push(i);
    }
  }

  careHealthProccedtoPayment() {
    // console.log("in initiate payment generali ",loi)
    this.loading = true;
    this.data = {
      quoteId: this.quoteDetails.quoteId,
      option:"0",
      insurer: "care-health",
    }
    this.serviceURLService.proceedtoPayCareHealth(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;

      this.txnId = successData.data.transactionId;
      //localStorage.setItem("transactionId", successData.data.transactionId);
      //localStorage.setItem("secureNowTxnRefNo", successData.data.secureNowTxnRefNo);
      // localStorage.setItem("LOI", loi)
      // console.log("successData txnId ",this.txnId);
      console.log('razorpay?txnId='+successData.data.transactionId +'&txnRefNo='+successData.data.secureNowTxnRefNo);
      this.router.navigate(['razorpay'],{ queryParams: { txnId: successData.data.transactionId, txnRefNo: successData.data.secureNowTxnRefNo}});
      //this.initPay();

    }, errorData => {
      console.log("Oops..!! Error");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }
  
  initPay(){
    // console.log("intipay txnId ",this.txnId);
    this.loading = true;
    this.options.order_id =  this.txnId;
      this.rzp1 = new this.winRef.nativeWindow.Razorpay(this.options);
      this.rzp1.open();
  }

  // careHealthProccedtoPayment() {
  //   const sendPayData = {
  //     quoteId: this.quoteDetails.quoteId,
  //     // email: this.proposal.email,
  //     // quoteDetailId: this.quoteDetails.quoteDetailId,
  //     // prospectId: this.quoteDetails.prospectId,
  //     option:"0",
  //     insurerName: "care-health",
  //     // firstName: this.proposal.firstName
  //   }
  //   this.serviceURLService.proceedtoPayCareHealth(sendPayData).subscribe((successData: any) => {
  //     this.loading = false;
  //     this.paymentGateData = successData.data;
  //     setTimeout(() => {
  //       this.royalSundarmForm.nativeElement.submit();
  //     }, 3000);
  //     //this.healthThankYou = true;
  //     //this.healthDetails = true;
  //     //this.toasterService.showSuccessToaster(successData.data.message);
  //   }, errorData => {
  //     this.loading = false;

  //   });
  // }

  nextStep(tab) {
    console.log(this.proposal);
    if (tab === '1') {
      this.insurerDetails = false;
      var checkProposalFlag = sessionStorage.getItem('proposalInsuredFlag');
      this.personFlag = sessionStorage.getItem('proposalInsuredFlag');
      // common details prefilled in self tab

      //this.proposal.insuredPersonGender1 = this.proposal.title;
      this.proposal.insuredPersonFirstName1 = this.proposal.firstName;
      this.proposal.insuredPersonLastName1 = this.proposal.lastName;
      this.proposal.insuredPersonDob1 = this.proposal.dob;

      if (checkProposalFlag == "1") {
        this.selfProposalTab = true;
      } else if (checkProposalFlag == "2") {
        this.selfProposalTab = true;
        this.spouseProposalTab = true;
      } else if (checkProposalFlag == "3") {
        this.selfProposalTab = true;
        this.spouseProposalTab = true;
        this.child1ProposalTab = true;
      } else if (checkProposalFlag == "4") {
        this.selfProposalTab = true;
        this.spouseProposalTab = true;
        this.child1ProposalTab = true;
        this.child2ProposalTab = true;
      } else if (checkProposalFlag == "5") {
        this.selfProposalTab = true;
        this.spouseProposalTab = true;
        this.child1ProposalTab = true;
        this.child2ProposalTab = true;
        this.child3ProposalTab = true;
      }
      this.proposalTab = true;
      this.nomineeDetails = true;
      this.healthDetails = true;
    } else if (tab === '2') {
      this.insurerDetails = true;
      this.proposalTab = true;
      this.nomineeDetails = false;
      this.healthDetails = true;
    } else {
      this.insurerDetails = true;
      this.proposalTab = true;
      this.nomineeDetails = true;
      this.healthDetails = false;
    }
  }

  backtoprevTab(tab) {
    if (tab === '2') {
      this.insurerDetails = true;
      this.proposalTab = false;
    } else if (tab === '3') {
      this.insurerDetails = false;
      this.nomineeDetails = true;
    } else {
      this.nomineeDetails = false;
      this.healthDetails = true;
    }
  }

  showThankYouModal(template: TemplateRef<any>) {
    this.openModal(template);
    this.router.navigate(['home']);
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-lg modal-dialog-centered', ignoreBackdropClick: false });
  }

  nomineeAddressAutoFill() {

    if (this.nomineeAddressAutoFillValue == "No") {
      this.nomineeAddressAutoFillValue = "Yes"
    } else {
      this.nomineeAddressAutoFillValue = "No";
    }
  }

  getGaurdianMinDobDate(date) {
    console.log(this.proposal.nomineeDob);
    // this.nomineeDOBrequired = false;
    var dobGaurdian = new Date(date);
    // var ageDifMsGaurdian = Date.now() - dobGaurdian.getTime();
    // var ageDateGaurdian = new Date(ageDifMsGaurdian); // miliseconds from epoch
    let ageDifferenceGaurdian = dobGaurdian.setFullYear(dobGaurdian.getFullYear() - 18);
    this.maxYearGaurdianDate = dobGaurdian.getFullYear();
    this.getGaurdianMinDate = new Date(ageDifferenceGaurdian);
  }

  getGaurdianAge(DOB) {
    let getDob = this.datepipe.transform(DOB, 'dd/MM/yyyy');
    var from = getDob.split("/");
    var today = new Date();
    var mydate = new Date(parseInt(from[2]), parseInt(from[1]) - 1, parseInt(from[0]));
    var age = today.getFullYear() - mydate.getFullYear();
    var m = today.getMonth() - mydate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < mydate.getDate())) {
      age--;
    }
    // this.proposal.guardianAge1 = age;
    return age;
  }

  // this is for same value in mrs and ms case
  getGenderValue(event) {
    if(event.target.options.selectedIndex === 1) {
      this.proposal.insuredPersonTitle1 = 'Mrs';
    } else if (event.target.options.selectedIndex === 2) {
      this.proposal.insuredPersonTitle1 = 'MS';
    } else {
      this.proposal.insuredPersonTitle1 = 'M';
    }
  }

  onAnsChange(value) {
    console.log(" Value is : ", value );
    this.goodHealthDeclaraion = value;
  }

  checkValue(){
    if( this.proposal.dob ){
      this.DOBrequired= true;
    }
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar) ) {
      event.preventDefault();
    }
  }

  getCityStateList(pinCode) {
    this.proposal.pincode = pinCode;
    this.loading = true;
    this.data = {
      "pincode": JSON.stringify(this.proposal.pincode)
    }
    this.serviceURLService.getCityStateList(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      // this.cityStateList = successData.data;
      // this.cityList = successData.data.cityList;
      // this.f.state = successData.data.state;
      this.loading = false;

      // if (this.cityList.length == 0) {
      //   var proceedButton = <HTMLInputElement>document.getElementById("proceedPayment");
      //   proceedButton.disabled = true;
      //   this.invalidPincode = true;
      // }
      // else {
      //   this.invalidPincode = false;
      // }
    }, errorData => {
      console.log("Oops..!! city/state list not found");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }
    

}
